export class Address {
  id: number;
  addressType: number;
  street: string;
  street2: string;
  city: string;
  region: string;
  postalCode: number;
  unit: number;
  currentAddress: boolean;
  physical: boolean;
  postal: boolean;
  billing: boolean;
  displayToClients: boolean;
  displayOnReportsAndForms: boolean;
  displayOnInvoices: boolean;
  clientId: number;
  clientLocationId: number;
  craId: number;
  isDefault: boolean = false;

  
  public get isValid() : boolean {
    return  (this.street != undefined && this.city != undefined && this.region != undefined && this.physical != undefined)
  }
  
}

export enum AddressType {
  Physical = 0,
  Postal = 1,
  Billing = 2,
  DisplayOnReportsAndForms = 3,
  DisplayOnInvoices = 4,
  DisplayToClients = 5
}
